import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';

import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { FC } from 'react';
import gtm from '@/utils/gtm';

interface NavProps {
    theme?: 'black' | 'white';
}
const Nav: FC<NavProps> = (props) => {
    const { theme = 'black' } = props;
    const { useLang, useRouter } = useGlobal();
    const router = useRouter();

    const { t } = useLang('OceanSmartMeterBackupSwitch');

    const dataA: EcoNavProductProps = {
        tabItems: [
            {
                value: '/ocean-smart-meter-backup-switch',
                label: t(`nav_product`),
                href: '/ocean-smart-meter-backup-switch',
            },
            // {
            //     value: '/ocean-smart-meter-backup-switch/support',
            //     label: t(`nav_support`),
            //     href: '/ocean-smart-meter-backup-switch/support',
            // },
            {
                value: '/ocean-smart-meter-backup-switch/specs',
                label: t(`nav_specs`),
                href: '/ocean-smart-meter-backup-switch/specs',
            },
        ],
        buyItems: [
            {
                value: 'Button',
                label: t(`nav_schedule`),
                href: `https://www.ecoflow.com/us/ocean-pro-consultation`,
                dataLayer: {
                    event: 'uaEvent',
                    event_name: 'product_navigation',
                    navigation_name: t(`nav_schedule`),
                    product_name: t(`nav_logo_text`),
                },
            },
        ],
    };

    return (
        <div className={styles.comp}>
            <EcoNavProduct
                productItems={[
                    {
                        value: 'logo',
                        label: t(`nav_logo_text`),
                        href: '/ocean-pro-home-solar-battery',
                    },
                ]}
                {...dataA}
                defaultTabActiveKey={router?.pathname || ''}
                theme={theme}
                onBuyChange={(item) => {
                    gtm.push(item.dataLayer);
                }}
            />
        </div>
    );
};

export default Nav;
